import { action, makeObservable, observable } from 'mobx';

export class PauseDeliveryModalStore {
  constructor() {
    makeObservable(this);
  }

  @observable minutes = '0';

  @observable isValid = true;

  @action public updateMinutes = (minutes: string | undefined, shouldValidate = true) => {
    this.minutes = minutes ? minutes : '';
    if (Number(minutes) > 99999) {
      this.minutes = '99999';
    }
    if (shouldValidate) this.validate(Number(this.minutes));
  };

  @action private validate = (minutes: number) => {
    if (minutes === 0 || minutes > 99999) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
  };
}

export const pauseDeliveryModalStore = new PauseDeliveryModalStore();
